const PREVIEW_WIDTH = window.innerWidth;
const PREVIEW_HEIGHT = window.innerHeight;
const isVertical = PREVIEW_WIDTH < PREVIEW_HEIGHT;

export default (theme) => ({
    cameraWrapper: {
        width: "100%",
        height: "100%",
        marginTop: theme.spacing(2),
    },
    videoOverlay: {
        display: "flex",
        justifyContent: "center",
        position: "relative",
    },
    videoStream: {
        overflow: "hidden",
        width: isVertical
            ? `calc(${PREVIEW_WIDTH}px - ${theme.spacing(4)})`
            : "auto",
        height: !isVertical
            ? `calc(${PREVIEW_HEIGHT - 64}px - ${theme.spacing(4)})`
            : "auto",
        borderRadius: "1rem",
        objectFit: "cover",
    },
    overlayImage: {
        position: "absolute",
        left: theme.spacing(2),
        right: 0,
        top: 0,
        bottom: 0,
        borderRadius: "1rem",
        height: `calc(${PREVIEW_WIDTH - 64}px - ${theme.spacing(4)})`,
        height: "100%",
        width: `calc(100% - ${theme.spacing(4)})`,
    },
    wrapper: {
        padding: theme.spacing(2),
    },
    previewWrp: {
        paddingTop: theme.spacing(2),
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        borderTop: `1px solid ${theme.palette.primary.lightBorder}`,
    },
    imagePreview: {
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
    },
    preview: {
        backgroundColor: theme.palette.background.darkBackground,
        width: PREVIEW_WIDTH,
        height: PREVIEW_WIDTH,
        objectFit: "cover",
    },
    loadingWrapper: {
        display: "flex",
        justifyContent: "center",
        marginTop: theme.spacing(8),
    },
    flash: {
        textAlign: "center",
        alignSelf: "center",
    },
    imageCapture: {
        textAlign: "center",
        alignSelf: "center",
    },
    menuItem: {
        textTransform: "capitalize",
    },
});
